import React from 'react';
import { FaHeart, FaRegHeart, FaEye } from 'react-icons/fa';

const MovieCard = ({ movie, onClick, isFavorite, onToggleFavorite }) => {
  const posterUrl = movie.Poster !== 'N/A'
    ? movie.Poster
    : 'https://via.placeholder.com/300x450/1a1a3e/6a6a8e?text=No+Poster';

  return (
    <div className="movie-card" onClick={() => onClick(movie.imdbID)}>
      <button
        className={`fav-btn ${isFavorite ? 'is-fav' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavorite(movie);
        }}
        aria-label={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      >
        {isFavorite ? <FaHeart /> : <FaRegHeart />}
      </button>

      <div className="poster-wrapper">
        <img src={posterUrl} alt={movie.Title} loading="lazy" />
        <div className="poster-overlay">
          <button className="view-details">
            <FaEye style={{ marginRight: 6, verticalAlign: 'middle' }} />
            View Details
          </button>
        </div>
      </div>

      <div className="card-info">
        <div className="card-title" title={movie.Title}>{movie.Title}</div>
        <div className="card-meta">
          <span className="card-year">{movie.Year}</span>
          <span className="card-type">{movie.Type}</span>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
